export default __webpack_public_path__ + "static/media/next-arrow.1aba2d0b.svg";